<app-home-page-card>
  <app-home-page-card-header [title]="'HOME_PAGE.SNAPSHOT_REPORTS.TITLE'" imageUrl="images/snapshots.svg">
    <ng-container *ngIf="subscriptionLimits$ | async as limit">
      <div [ngSwitch]="limit.limitMax" class="snapshot-usage">
        <div *ngSwitchCase="-1">
          <div class="no-limit {{ !(limit.limitTitle || limit.limitImageUrl) ? 'no-pad' : '' }}">
            {{ 'SUBSCRIPTIONS.NO_LIMIT' | translate }}
          </div>
        </div>
        <div *ngSwitchCase="0"></div>
        <div *ngSwitchDefault class="limit-row-container col-xs-12 row">
          <div class="limit-bar-container col-xs-12 col-md-5">
            <div class="limit-bar"></div>
            <div
              class="limit-bar limit-bar-progress"
              [style.width.%]="
                (limit.currentValue / limit.limitMax > 1 ? 1 : limit.currentValue / limit.limitMax) * 100
              "
            ></div>
          </div>
          <div class="toolbar-count col-xs-12 col-md-7">
            <a
              *ngIf="userCanAccessBilling$ | async; else noLinkToMyPlan"
              [attr.data-action]="'snapshot-my-plan'"
              routerLink="/subscription-tier/my-plan"
            >
              <span>
                {{ 'SUBSCRIPTIONS.LIMIT_COUNT' | translate: limit }}
              </span>
            </a>
            &nbsp;
            <ng-template #noLinkToMyPlan>
              <span>
                {{ 'SUBSCRIPTIONS.LIMIT_COUNT' | translate: limit }}
              </span>
            </ng-template>
            <span>
              {{ 'HOME_PAGE.SNAPSHOT_REPORTS.SNAPSHOT_FREE_REPORTS_INFO' | translate }}
            </span>
          </div>
        </div>
      </div>
    </ng-container>
  </app-home-page-card-header>
  <ng-container *ngIf="businesses$ | async as businesses">
    <app-home-page-card-content *ngIf="businesses.length > 0" [title]="contentTitle$ | async">
      <div *ngFor="let business of businesses" class="row">
        <div class="col-xs-8">
          <a
            [attr.data-action]="'snapshot-business-details'"
            [routerLink]="'/businesses/accounts/' + business.accountGroup.accountGroupId + '/details'"
          >
            {{ business.accountGroup?.napData?.companyName }}
          </a>
        </div>
        <div class="col-xs-2 mat-icon-container">
          <app-create-snapshot
            [attr.data-action]="'snapshot-create'"
            [accountGroup]="business.accountGroup"
            [originDetails]="'dashboard'"
            [showText]="false"
            [glxyTooltip]="'HOME_PAGE.SNAPSHOT_REPORTS.CREATE_SNAPSHOT_REPORT_TOOLTIP'"
          ></app-create-snapshot>
        </div>
        <div class="col-xs-2 mat-icon-container">
          <a [attr.data-action]="'snapshot-open-business-app'" [href]="business.vbcEntryInfo.url" target="_blank">
            <button mat-icon-button color="primary" [glxyTooltip]="'OVERVIEW.OPEN_BUSINESS_APP'" type="button">
              <mat-icon>store</mat-icon>
            </button>
          </a>
        </div>
      </div>
    </app-home-page-card-content>
  </ng-container>
  <app-home-page-card-footer
    cardContext="snapshot"
    [courseParams]="courseParams"
    [ctaButtons]="[
      {
        text: 'HOME_PAGE.SNAPSHOT_REPORTS.CREATE_SNAPSHOT_REPORTS',
        url: manageAccountsPage,
        queryParams: queryParams
      }
    ]"
  >
    <div class="row col-xs-12 home-page-card-learn-more-content-info">
      <p>
        {{ 'HOME_PAGE.SNAPSHOT_REPORTS.SNAPSHOT_REPORTS_INFO' | translate }}
      </p>
      <div style="clear: both"></div>
      <br />
    </div>
  </app-home-page-card-footer>
</app-home-page-card>
